import { createAction } from '@ngrx/store';

export const onlineAction = createAction('[Browser] Online');
export const offlineAction = createAction('[Browser] Offline');
export const wakeAction = createAction('[Browser] Wake');
